const items = [
  {
    type: 'Advisory Brief',
    title: 'Deployment Readiness in Autonomous Robotics Systems',
    desc: 'A structured framework for evaluating technical and operational readiness before large-scale robotics deployment.',
  },
  {
    type: 'Technical Note',
    title: 'Physical AI in Constrained Environments',
    desc: 'An analysis of perception and decision-making constraints for embodied AI systems operating in unstructured physical settings.',
  },
  {
    type: 'Capability Brief',
    title: 'Cross-border Infrastructure Validation',
    desc: 'Methodology and expert coordination model for technical validation work spanning multiple regulatory jurisdictions.',
  },
];

export default function Proof() {
  return (
    <section className="py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 mb-16">
          <h2 className="text-3xl md:text-4xl font-700 tracking-tight text-brand-text leading-snug">
            Expertise you<br />can verify
          </h2>
          <p className="text-brand-text/60 leading-relaxed self-end">
            Our work is grounded in technical substance — from advisory briefs to applied evaluations and domain-specific insight.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {items.map(item => (
            <div key={item.title} className="border border-brand-gray p-8 flex flex-col gap-3">
              <span className="text-xs font-medium text-brand-blue tracking-widest uppercase">{item.type}</span>
              <h3 className="text-sm font-600 text-brand-text leading-snug">{item.title}</h3>
              <p className="text-sm text-brand-text/55 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
